import type { IconProps } from "../types";

export const PinOff = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M12 17v5" />
    <path d="M15 9.3V6h3V2H7.9" />
    <path d="m2 2 20 20" />
    <path d="M9 9v2l-4 3v3h12" />
  </svg>
);
